import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommentsAdapterService } from '../comments/comments-adapter.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesModalComponent } from './files-modal/files-modal.component';
import { ToastrService } from 'ngx-toastr';
import { WorksheetCommentsRequest } from '../../api/models/bom-line';
import { Comment } from '../../api/models/comment';
import { ProjectService } from '../../api/services/project.services';
import { CommentService } from '../../api/services/comment.service';
import { AuthService } from '../../api/services/auth.service';
import { FileUploadService } from '../../api/services/file-upload.service';
import { RoleRequest } from '../../api/models/role-assignment-map';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {

  @Input() comments: any[];
  @Input() level = 1;

  newCommentBody: string = '';
  isInternal = false;
  fileIds: string[] = [];
  fileIdsCount: number = 0;
  @Output() refreshCommentInWs = new EventEmitter<string>();

  constructor(private commentsAdapterService: CommentsAdapterService,
              private modalService: NgbModal,
              private toastr: ToastrService,
              private projectService: ProjectService,
              private commentService: CommentService,
              private authService: AuthService,
              private fileUploadService: FileUploadService
  ) { }

  addNewComment() {
    if(!this.newCommentBody.trim() && (this.fileIds && this.fileIds.length === 0)){
      this.showWarningMsg('Please provide comment text or attach a file.');
    } else {
      this.commentsAdapterService.createComment(this.newCommentBody, this.isInternal, null, this.fileIds)
      .subscribe(comment => {
        comment.canEditOrDelete = true;
        this.comments.push(comment);
        this.isInternal = false;
        this.projectService.sendWSCommentNotification(this.getCreateWSCommentObject(comment)).subscribe();
        this.showSucessMessage("Comment Added successfully !!");
        this.cancelComment();
      });
    }    
  }

  openFilesModal(type: string) {
    const modalRef = this.modalService.open(FilesModalComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.type = type;

    modalRef.result.then(result => {
      this.fileIds = result;
      this.fileIdsCount = this.fileIds.length;
    }).catch(() => { 
      //Empty catch block
    });
  }

  cancelComment() {
    this.newCommentBody = '';
    this.fileIds = [];
    this.fileIdsCount = 0;
  }

  private showWarningMsg(msg: string){
    this.toastr.warning(msg, 'Warning!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  private showSucessMessage(message?: string) {
    this.toastr.success(message, 'Succcess!', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
  }


  getCreateWSCommentObject(comment: Comment, isEdit: boolean = false, isDelete: boolean = false) {
    let wsCompRequest = new WorksheetCommentsRequest();
    wsCompRequest.bomId = comment.universalObjectString.split('~')[1];
    if(isEdit || isDelete){
      wsCompRequest.commentUserId = comment.updatedBy;
    }else{
      wsCompRequest.commentUserId = comment.commenterUserId;
    }
    if(isDelete){
      wsCompRequest.fileId = null;
    }else{
    wsCompRequest.fileId = comment.fileIds ? comment.fileIds[0] : null;
    }
    wsCompRequest.commentUserId = comment.commenterUserId;
    wsCompRequest.comments = comment.body;
    wsCompRequest.isEdit = isEdit ;
    wsCompRequest.isDelete = isDelete;
    return wsCompRequest;
  }

  updateComment(newComment: Comment) {
    if (!newComment.body.trim() && (newComment.fileIds && newComment.fileIds.length === 0)) {
      this.showWarningMsg('Please provide comment text or attach a file.');
    } else {
      this.commentService.getComment(newComment.id).subscribe(
        (commentData) => {
          const oldComment = commentData.body;
          const wsCommentsDTO = this.getCreateWSCommentObject(newComment, true);
          wsCommentsDTO.oldComment = oldComment;
          this.updateCommentsAndSendNotification(newComment, wsCommentsDTO);
        },
        (error) => {
          console.error('Error fetching comment:', error);
        }
      );
    }   
  }

  private updateCommentsAndSendNotification(newComment: Comment, wsCompDto:WorksheetCommentsRequest) {
    this.commentService.updateComment(newComment.id, newComment)
      .subscribe(comment => {
        this.isInternal = false;
        this.projectService.sendWSCommentNotification(wsCompDto).subscribe();
        this.showSucessMessage("Comment Updated successfully !!");
        this.cancelComment();
        if (!newComment.fileIds && wsCompDto.fileId) {
          this.deleteImage(wsCompDto.fileId);
        }
        this.refreshComments(comment);
      }, error => {
        const errorMessage = error.error.message != null ?
                            error.error.message :"Comment Updation failed!!!!";
                            this.showWarningMsg(errorMessage);
      });
  }

  deleteComment(comment: Comment) {
    const wsComponent = this.getCreateWSCommentObject(comment, false, true);
    let fileId = comment.fileIds ? comment.fileIds[0] : null;
    this.commentService.deleteComment(comment.id, this.authService.getUserId())
      .subscribe(() => {
        this.isInternal = false;
        this.projectService.sendWSCommentNotification(wsComponent).subscribe();
        this.showSucessMessage("Comment Deleted successfully !!");
        this.cancelComment();
        this.deleteImage(fileId);
        this.refreshComments(comment);
      });
  }   
  

  refreshComments(comment: Comment) {
     this.refreshCommentInWs.emit(new Date().toISOString());
  }

  ngOnInit() {}

  deleteImage(fileId: string) {
    if (fileId && fileId != null){
      console.log("calling delete image"+fileId);
     this.fileUploadService.deleteImage(fileId).subscribe();
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/comments.component.ts